import { render, staticRenderFns } from "./updateProduct.vue?vue&type=template&id=21370760&"
import script from "./updateProduct.vue?vue&type=script&lang=js&"
export * from "./updateProduct.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports